import { useReactiveVar } from '@apollo/client/react';
import { FolderOff, FolderOpen } from '@mui/icons-material';
import { Badge, Button, Grid } from '@mui/material';
import { useContext } from 'react';

import NotesSection from '../../Notes/NotesSection';
import { DEFAULT_SECTION } from '../../types';
import StepperContentContainer from '../StepperContentContainer';

import KickOffDocumentDrawer from './KickOffDocumentDrawer';

import { KickOffContext } from '@/Contexts/KickOff';
import { openKickOffDocumentDrawer } from '@/graphql/reactiveVars';
import { objectLength } from '@/utils/helperFunctions';

const KickoffActions: React.FC = () => {
  const { noteSections, setNoteSections, updateNotes, kickoffData, projectData } = useContext(KickOffContext);
  const openDocumentDrawer = useReactiveVar(openKickOffDocumentDrawer);

  const totalDocs = objectLength(kickoffData?.attachments) + objectLength(projectData?.attachments);

  const handleSectionAdd = () => {
    const updated = [...noteSections, DEFAULT_SECTION];
    setNoteSections(updated);
    updateNotes(updated);
  };

  return (
    <StepperContentContainer>
      <Grid size={openDocumentDrawer ? 6 : 12}>
        <Grid container size={12} justifyContent="space-between" mb={1}>
          <Button variant="outlined" onClick={handleSectionAdd}>
            Add Section
          </Button>
          <Badge badgeContent={totalDocs} color="primary" showZero={false}>
            <Button
              variant={openDocumentDrawer ? 'contained' : 'outlined'}
              startIcon={openDocumentDrawer ? <FolderOpen /> : <FolderOff />}
              onClick={() => openKickOffDocumentDrawer(!openDocumentDrawer)}
            >
              {openDocumentDrawer ? 'Close Documents' : 'Documents'}
            </Button>
          </Badge>
        </Grid>
        <NotesSection noteSections={noteSections} setNoteSections={setNoteSections} updateNotes={updateNotes} />
      </Grid>
      {openDocumentDrawer && <KickOffDocumentDrawer />}
    </StepperContentContainer>
  );
};

export default KickoffActions;
